import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import {
  createCluster,
  deleteCluster,
  updateCluster,
} from '../../../store/ClusterReducer'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'
import View from './View'

export const ClusterForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.cluster)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        view: View,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(createCluster(values)).then(() => {
            return true
          }),
        update: async (values) =>
          dispatch(updateCluster(values)).then(() => {
            return true
          }),
        view: async () => true,
        delete: async (values) =>
          dispatch(deleteCluster(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

ClusterForm.displayName = 'ClusterForm'

export default ClusterForm
